<!-- eslint-disable no-prototype-builtins -->
<template>
    <template-page
        :page-name="pageTitle"
        :context-action-bar="true"
        search-event="sales-funnil-deals-search"
        add-event="sales-deals-add"
        filters-apply-event="filter-list-funnel-deals"
        add-button-text="Adicionar Cliente"
        clear-filters-event="clear-filters-funnel-deals"
        search-input-placeholder="Buscar cliente"
        body-design="no-p-coll-1-row-2"
        menu-card-icon="fal fa-cog"
        :filter-storage-text="layout.filterStorageText"
        has-filters-storage
        @input='loadFilters'
    >
        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left> Vendas &#8226; Clientes </template>
                <template v-if="hasAnyBulkPermission" #right >
                    <div>
                        <span class="text-activate-multiple">Use Alt + Shift + S para
                            <strong class="text-activate-multiple-strong" @click="toggleMultiSelectMode">{{isMultiSelectMode ? "desselecionar" : "selecionar"}}</strong> 
                            múltiplos cards.
                        </span> 
                    </div>
                </template>
            </ui-breadcrumbs>
        </template>


        <template  #menuCard>
            <div class="menu-card">
                <p class="menu-card-text">Configurações</p>
                <template v-if="$mx_userHasAdminPermissions">
                    <router-link :to="{name: 'configurations.salesfunnel.general'}" @click.native="() => sendGtmEvent(gtm.funnelConfig)">Configurações Gerais do Funil</router-link>
                    <router-link :to="{name: 'configurations.salesfunnel.stagestatus'}" @click.native="() => sendGtmEvent(gtm.stageStatus)">Etapas e Status</router-link>
                    <router-link :to="{name: 'configurations.customers.idleness'}" @click.native="() => sendGtmEvent(gtm.idleRules)">Regras de Ociosidade</router-link>
                    <router-link :to="{name: 'configurations.salesfunnel.actionsrules'}" @click.native="() => sendGtmEvent(gtm.funnelActions)">Ações do Funil</router-link>
                </template>
                <div class="menu-card-switch-container">
                    <ui-switch
                        :value="isDisplayContactDetails"
                        :checked="isDisplayContactDetails"
                        design="xs primary"
                        label="Exibir dados de contato no card"
                        @input="$emit('update:isDisplayContactDetails', $event)"
                    />
                </div>
            </div>
        </template>

        <template #contextActionBar>
            <slot name="bulk" />
        </template>

        <template #content>
            <slot name="body"/>

            <ui-user-info-modal name="user-info" />
            <ui-delete-deal-modal name="delete-deal" sucess-event="sales-funnil-deals-delete" />
            <ui-select-user-modal name="select-user" />
            <ui-broker-modal name="sales-deals-select-broker" />
            <ui-deal-stage-status-modal name="sales-deals-select-stage-status" success-event="modal-result-funnel-move-to-status" />
            <ui-procedure-modal name="deal-multiple-precedure" success-event="sales-funnil-deals-search" />
            <ui-deal-create-historical-modal name="sales-deals-select-create-historical" />
            <ui-move-to-modal name="funnel-move-to" />
            <ui-choose-unit-reserve-modal name="choose-unit-reserve" />
            <ui-duplicate-deal-modal name="duplicate-deal-modal" />
        </template>

        <template #filters>
            <form>
                <div v-for="(filter, index) in filters" :key="index">
                    <div v-if="filter.component === 'datepicker-range' && !filter.hidden" class="date-range">
                        <ui-date-range
                            v-model="filter.params.value"
                            :label="filter.label"
                            size="md" />
                    </div>

                    <ui-select-v2
                        v-else-if="filter.component === 'select-tags' && !filter.hidden"
                        v-model="filter.params.value"
                        :data="filter.options"
                        :label="filter.label"
                        :item-label="filter.itemLabel"
                        :search="filter.searchAble"
                        :multiple="filter.multiple"
                        :ajax-search="filter.ajaxSearch"
                        :search-event="filter.searchEvent"
                        :return-value="filter.returnValue || 'object'"
                        :group-by="filter.groupBy || ''"
                        :loading="filter.loading"
                        :is-title="filter.isTitle"
                        :show-button-apply-button="false"
                        :open-event="filter.openEvent"
                        design="br-all mgb-15"
                        size="md"
                        @input="call(filter.handler, $event)" />
                </div>
            </form>
        </template>
    </template-page>
</template>

<script>
	import TemplatePage from '@/templates/page-list/index.vue'

	import { uiBreadcrumbs } from '@/components/ui'
	import { uiDateRange, uiSelectV2, uiSwitch } from '@/components/ui/form'

	import {
		uiBrokerModal,
		uiChooseUnitReserveModal,
		uiDealCreateHistoricalModal,
		uiDealStageStatusModal,
		uiDeleteDealModal,
		uiDuplicateDealModal,
		uiMoveToModal,
		uiSelectUserModal,
		uiUserInfoModal,
	} from '@/components/ui-facilita/modals'

	import uiProcedureModal from '@/components/ui-facilita/sales/procedure-modal/index.vue'

	import { defaultFilters } from '../data'

	import { funnel, team } from '@/services/axios'
	import { storage } from '@/services/storage'
	import { mapGetters } from 'vuex'

	import {
		alertMixin,
		helpersMixin,
		permissionsMixin,
		utilMixin
	} from '@/mixins'
	import { defaultGtm } from './default'

	export default {
		name: 'ui-kambam-template',
		components: {
			TemplatePage,
			uiBreadcrumbs,
			uiBrokerModal,
			uiDealStageStatusModal,
			uiDealCreateHistoricalModal,
			uiDateRange,
			uiProcedureModal,
			uiSelectV2,
			uiSelectUserModal,
			uiUserInfoModal,
			uiDeleteDealModal,
			uiMoveToModal,
			uiChooseUnitReserveModal,
			uiDuplicateDealModal, 
            uiSwitch
		},

		mixins: [
			alertMixin,
			helpersMixin,
			permissionsMixin,
			utilMixin
		],

		props: {
			pageTitle: {
				type: String,
				default: 'Funil de Vendas'
			}, 
            isPermissionToViewContactDetails: {
                type: Boolean,
                default: false
            },
            isDisplayContactDetails: {
                type: Boolean,
                default: false
            },
            isMultiSelectMode: {
                type: Boolean,
                default: false
            },
            hasPermissionToChangeOwnerInBulk: {
                type: Boolean,
                default: false
            }
		},

		data() {
			return {
				layout: {
					showFiltersMenu: false,
					filterStorageText: 'Limpar filtros',
				},
				configurations: {
					manager: {
						label: storage.get('label_manager'),
					},
					broker: {
						label: storage.get('label_broker'),
					},
				},
				filters: [...defaultFilters()],
				gtm: { ...defaultGtm() },
				channels: {
					page: 1,
					perPage: 1000,
					totalPage: 1
				},
				/*
				* Per page estará com a quantidade de 1000 até
				* adicionar uma busca no select2 que trabalhe
				* com dados já carregado, hj o tipo que existe
				* pede para  adicionar pelo menos duas caracters
				* para trazer o os dados via pesquisa, assim que
				* criar um novo o perpage deve trazer somente 20
				* e a busca deve ser pela requisição.
				 */
				channelPrimaryLoad: false,
			}
		},
		computed: {
			...mapGetters('auth', {
				user: 'getUser',
			}),

			/**
			 * Computed property que retorna os dados dos filtros a serem passados
			 * para o datatable
			 */
			tableFiltersComputed() {
				return this.filters.map(filter => {
					let params = { ...filter.params }
					let value = filter.params.value
					switch(filter.params.name) {
  						case 'origin_id':
						case 'product_id':
						case 'funnel_stage_status_id':
							params.value = this.filterMaker(filter.params.value, '^', '$')
							break

						case 'tags':
							params.value = this.filterMaker(filter.params.value)
							break

						case 'tasks':
							if (value === 2) value = ''
							else if (value === 3) value = '0'
							params.value = value
							break

                        case 'reserves':
                            if(value === 2) value = "0"
                            if(value === 1) value = "1"
                            if(value === 3) value = ""
                            params.value = value
                            break
					}
					return params
				})
			},

            hasPermissionToChangeStageInBulk() {
                const user = JSON.parse(localStorage.getItem('fac_user_logged') || '{}')
                return (
                    user?.config_permissions?.userPrivilegedMoveDeal === 1 &&
                    user?.config_permissions?.bulkActionMoveDeal === 1
                )
            },

            hasAnyBulkPermission() {
                return this.hasPermissionToChangeStageInBulk || this.hasPermissionToChangeOwnerInBulk
            },
		},


		mounted() {
			this.$root.$on('select-v2-ajax-search-channel-next-event', async () => {
				//adiciona mais uma requisição para o scrool
				if(this.channels.page > this.channels.totalPage) return

				await this.requisitionFiltersChagerd('Canal', `?per_page=${this.channels.perPage}&page=${this.channels.page}`)
			})

			this.$root.$on('go-to-proposal', () => {
				const route = this.$router.resolve({
					name: 'sales.simulation',
				})
				window.open(route.href, '_blank')
			})

			/** Redireciona para o guia de cadastro de negócios/clientes do painel Legado */
			this.$root.$on('sales-deals-add', () => {
				this.sendGtmEvent(this.gtm.addDeal)

				this.$root.$emit('modal-open-create-deal-modal')
				this.$root.$emit('create-proposal-modal', false)
			})

			/** Trata o evento que limpa os filtros e refaz a listagem */
			this.$root.$on('clear-filters-funnel-deals', async () => {
				this.sendGtmEvent(this.gtm.clearFilters)
				await this.resetFilters()
				this.$root.$emit('clear-all-dates')
				this.$root.$emit('set-filter-selected-active', this.tableFiltersComputed)
				this.$emit('filter', this.tableFiltersComputed)
			})

			this.$root.$on('sales-funnil-deals-search', (data) => {
				this.sendGtmEvent(this.gtm.searchDeal)

				this.$emit('search', data)
			})
			this.$root.$on('filter-list-funnel-deals', () => {
				this.$root.$emit('set-filter-selected-active', this.tableFiltersComputed)
				this.$emit('filter', this.tableFiltersComputed)
			})

			this.$root.$on('sales-funnil-deals-delete', (data) => {
				this.$emit('delete', data)
			})

			this.$root.$on('select-v2-open-event-kanban-filter-tags', () => {
				this.requisitionFiltersChagerd('Tags')
			})
			this.$root.$on('select-v2-open-event-kanban-filter-origens', () => {
				this.requisitionFiltersChagerd('Origens')
			})

			this.$root.$on('select-v2-open-event-kanban-filter-channel', async () => {
				if(!this.channelPrimaryLoad) {
					this.channelPrimaryLoad = true
					await this.requisitionFiltersChagerd('Canal', `?per_page=${this.channels.perPage}&page=${this.channels.page}`)
				}
			})

			this.$root.$on('select-v2-open-event-kanban-filter-users-sdr', () => {
				this.requisitionFiltersChagerd('Usuários')
			})

			this.$root.$on('select-v2-ajax-search-kanban-search-users-sdr', async (search) => {
				await this.requisitionFiltersPagination('Usuários', search)
			})

		},

		beforeDestroy() {
            window.removeEventListener('keydown', this.handleKeyShortcut)
			this.$root.$off('sales-deals-add')
			this.$root.$off('filter-list-funnel-deals')
			this.$root.$off('clear-filters-list-deals')
			this.$root.$off('clear-filters-funnel-deals')
			this.$root.$off('go-to-proposal')
			this.$root.$off('select-v2-open-event-kanban-filter-tags')
			this.$root.$off('sales-funnil-deals-delete')
			this.$root.$off('select-v2-ajax-search-channel-next-event')
			this.$root.$off('select-v2-open-event-kanban-filter-channel')
			this.$root.$off('select-v2-open-event-kanban-filter-origens')
			this.$root.$off('select-v2-open-event-kanban-filter-users-sdr')
			this.$root.$off('select-v2-ajax-search-kanban-search-users-sdr')
		},

		methods: {
			/**
			 * Chama dinamicamente um handler para tratar o evento do filtro
			 */
			call(handler, event) {
				if (handler) this[handler](event)
			},

			showList() {
				this.sendGtmEvent(this.gtm.funnelPage)
				this.$router.push({
					name: 'sales.deals.list',
				})
			},

			/**
			 * Handler para tratar o evento de quando uma etapa for selecionada, de modo
			 * a carregar os status desta etapa
			 */
			async funnelStageHandler(value) {
				try {
					const index = this.filters.findIndex(filter => filter.params.name === 'funnel_stage_status_id')

					if (!value) return

					const { data } = await funnel.getStatusByStage(value)

					if (!data.length) return

					this.filters[index].options = data

				} catch (error) {
					this.$mx_alertError(error)
				}
			},
			/**
			 * Handler para tratar o evento de quando uma equipe for selecionada, de modo
			 * a carregar os gerentes desta equipe
			 */
			teamHandler(value) {
				/** Check if the event value is valid */
				const isValid = value && (typeof value === 'object' ? value.length : true)

				if (isValid) {
					team.getManagersByTeam(value)
						.then(response => {
							const index = this.filters.findIndex(filter => filter.params.name === 'manager_id')
							this.filters[index].options = response.data
							if (this.user.user_group === 'manager') {
								this.call(this.filters[index].handler, this.filters[index].params.value)
							}
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
				}
			},
			/**
			 * Handler para tratar o evento de quando um gerente for selecionado, de modo
			 * a carregar os corretores pelos quais este é responsável
			 */
			managerHandler(value) {
				/** Check if the event value is valid */
				const isValid = value && (typeof value === 'object' ? value.length : true)

				if (isValid) {
					const index = this.filters.findIndex(filter => filter.params.name === 'broker_id')
					team.getBrokersByManager(value)
						.then(response => {
							this.filters[index].options = response.data
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
				}
			},

			filterMaker(arr, prefix = '', sufix = '') {
				if (!Array.isArray(arr)) return null
				return arr.map(e => `${prefix}${e}${sufix}`).join(',')
			},

			/**
			 * Remove o prefíxo e sufíxo das opções selecionadas em um filtro
			 *
			 * @param {String} value
			 * @param {String} prefix
			 * @param {String} sufix
			 */
			revertFilter(value, prefix = '', sufix = '') {
				if (typeof value === 'string') {
					value = value.split(',').map(e => {
						return e.replace(prefix, '').replace(sufix, '')
					})
				}

				return value
			},

			loadFilters(filters) {
				if (filters) this.filters.map(res => {
                	res.params = filters.find(({ name }) => name == res.params.name)
            	})

				for (const filter of this.filters) {
					switch (filter.params.name) {
						case 'team_id':
							/**
							 * Caso o usuário logado seja do tipo gerente ou corretor, seleciona a equipe deste
							 * e desabilita o filtro de equipes
							 */
							if (['manager', 'broker'].includes(this.user.user_group)) {
								if (this.user.user_group === 'manager') {
									filter.params.value = this.user.team ? this.user.team.id : null
								}

								filter.disabled = true
								filter.hidden = true
							}
							break

						case 'manager_id':
							filter.label = this.configurations.manager.label

							/**
							 * Caso o usuário logado seja do tipo gerente ou corretor, carrega o manager_id deste
							 * e desabilita o filtro de gerentes
							 */
							if (['manager', 'broker'].includes(this.user.user_group)) {
								if (this.user.user_group === 'manager') {
									filter.params.value = this.user.manager_id || null
								}

								filter.disabled = true
								filter.hidden = true
							}
							break

                        case 'reserves': {
                            let value = filter?.params?.value ?? null
                            if (value === '0')      value = 2
                            else if (value === '1') value = 1
                            else if (value === '')  value = 3

                            filter.params.value = value
                            break
                        }

                        case 'tasks': {
                            let value = filter?.params?.value ?? null 
                            if (value === '')       value = 2
                            else if (value === '0') value = 3

                            filter.params.value = value
                            break
                        }

						case 'broker_id':
							filter.label = this.configurations.broker.label

							if (this.user.user_group === 'broker') {
								filter.disabled = true
								filter.hidden = true
							}
                        
						}
						/** Verifica se o filtro possui um handler e se seu valor já foi definido no pré-processamento */
						if (filter.handler && filter.params.value) this.call(filter.handler, filter.params.value)

						if (filter.service && filter.requestOnStart && !filter.alreadyRequested) {
							(() => import('@/services/axios/modules/'+ filter.service + '.js'))().then(service => {
								const api = service.default.build()
								let params = ['']
								if (filter.serviceParams) params = [...filter.serviceParams]

								api[filter.method](...params).then(response => {
									let data = []
									/** Verifica se a requisição retornou uma paginação */
									// eslint-disable-next-line no-prototype-builtins
									if (response?.data?.hasOwnProperty('total')) {
										data = [...response.data.data]

									/** Verifica se a requisição retornou um array */
									// eslint-disable-next-line no-prototype-builtins
									} else if (response?.data?.hasOwnProperty('length')) {
										data = [...response.data]

									/** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
									} else if (typeof response.data === 'object') {
										data = { ...response.data }
									}

									/** Verifica se os resultados necessitam ser formatados */
									if (filter.parse) {
										filter.options = filter.parse(data)
									} else {
										filter.options = Object.values(data)
									}
								})

								filter.alreadyRequested = true
							}).catch(error => {
								if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
							})
						}
					}

				this.$emit('filter', this.tableFiltersComputed)
			},

			requisitionFiltersChagerd(label, newParams) {
				let filter = this.filters.find(item => item.label == label)
				this.requisitionChange(label, filter, newParams)
			},

			async requisitionFiltersPagination(label, search) {
				let filter = this.filters.find(item => item.label == label)
				/**
				 *  verifica se foi feito uma pesquisa no search
				 */
				if(!search.nextPage) {
					/**
					 * reseta os parametros para iniciar uma nova pesquisa
					 */
					filter.serviceParams[1].search = search.search
					filter.serviceParams[1].page = 1
					filter.options = []
					/**
					 * caso search veio vazia retorna os valores padrões
					 */
					if(search.search == '') {
						await this.requisitionChange(label, filter)
						return
					}
				}

				await this.requisitionChange(label, filter)

			},

			requisitionChange(label, filter, newParams) {
				if((filter?.serviceParams?.[1] && filter.serviceParams[1].page > filter.lastPage) || filter.loading) return
				if ((filter && !filter.requestOnStart && !filter.alreadyRequested) || filter.lastPage) {
					(() => import('@/services/axios/modules/'+ filter.service + '.js'))().then(async service => {
						await this.resolveFilter(filter, service, newParams)
						if(label == 'Canal')this.channels.page = this.channels.page + 1
						filter.alreadyRequested = label !== 'Canal'
					}).catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
				}
			},

			async resolveFilter(filter, service, newParams) {
				filter.alreadyRequested = true
				const api = service.default.build()
				let params = ['']
				if (filter.serviceParams) params = newParams ? [ newParams ] : [...filter.serviceParams]

				filter.loading = true
				let request = await this.requestApi(api, filter, params)
				let data = request.data ? request.data : request

				if(data.error) {
					filter.loading = false
					return
				}
				/** Verifica se os resultados necessitam ser formatados */
				if (filter.parse) {
					filter.options = filter.options && filter.options.length > 0 ? filter.options.concat(filter.parse(data)) : filter.parse(data)
				} else {
					data.map(value => {
						value.type = value.type == 'system' ? 'Sistêmica' : value.type == 'user' ? 'Usuário': value.type
						filter.options.push(value)
					})
				}
				if(request.lastPage) this.loadPaginate(filter, request.lastPage)

				filter.loading = false
			},

			async requestApi(api, filter, params) {
				let data
				await api[filter.method](...params).then( response => {
					this.hasRequesting = false
					/** Verifica se a requisição retornou uma paginação */
					if (Object.prototype.hasOwnProperty.call(response.data, 'total')) {
						this.channels.totalPage = Math.ceil(response.data.total / response.data['per_page'])
						data = {lastPage: response.data.last_page, data: [...response.data.data]}
					/** Verifica se a requisição retornou um array */
					} else if (Object.prototype.hasOwnProperty.call(response.data, 'length')) {
						data = [...response.data]

					/** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
					} else if (typeof response.data === 'object') {
						data = { ...response.data }
					}
				}).catch( e => {
					data = {error: e, status: 'error'}
				})
				return data
			},
			loadPaginate(filter, lastPage) {
				this.filters.map(item => {
					if(item.label == filter.label) {

						item.lastPage = lastPage
						item.serviceParams[1].page++
					}
				})
			},

			resetFilters() {
				for (const filter of this.filters) {
					const validate = filter.component === 'select-tags' && filter.multiple
					filter.params.value = validate ? [] : null
				}
			},

			toOldFunnel() {
				this.sendGtmEvent(this.gtm.oldPanel)
				window.location.href = this.oldPanelLink('vendas/negocios/funil')
			},

			sendGtmEvent(gtm){
				if(gtm) this.$gtm.trackEvent(gtm)
			},
            
            handleChangeDisplay(newValue) {
                storage.set('show-contacts-kanban', newValue)

                this.$emit('update:isDisplayContactDetails', newValue)
            },
            handleKeyShortcut(e) {
                const isAlt = e.altKey
                const isShift = e.shiftKey
                const isS = e.key.toLowerCase() === 's'
                        
                if (isAlt && isShift && isS) {
                  e.preventDefault()
                  this.toggleMultiSelectMode()
                }
            },
            toggleMultiSelectMode() {
                this.$emit('update:isMultiSelectMode', !this.isMultiSelectMode)
                this.$root.$emit('clear-selected-deals')
            }
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>
